import React from 'react';
import AvatarGroup from '@atlaskit/avatar-group';
import styled from '@emotion/styled';
import { Admin, BillingAdminsPreferences } from './emails-details-section/billing-and-licensing-emails';
import { NotificationLevel } from './emails-details-section/use-billing-admins-preference-handler';

interface AdminAvatarGroupProps {
  selectedAdmins: Admin[];
  billingAdminsPreferences?: BillingAdminsPreferences[];
  shouldManageBillingProfileNotifications?: boolean;
}

const AdminAvatarGroupWrapper = styled.div({
  position: 'sticky',
  paddingTop: '10px',
  paddingBottom: '10px',
});

export const AdminAvatarGroup = ({
  selectedAdmins,
  billingAdminsPreferences,
  shouldManageBillingProfileNotifications,
}: AdminAvatarGroupProps) => {
  let selectedAdminsData: any = [];
  if (shouldManageBillingProfileNotifications) {
    selectedAdminsData = billingAdminsPreferences
      ?.filter((billingAdmin) => billingAdmin?.isEnabled || billingAdmin?.level === NotificationLevel?.INVOICE_GROUP)
      ?.map((admin: Admin) => {
        return {
          key: admin.atlassianAccountId,
          name: admin.fullName,
          src: admin.picture,
          status: 'approved',
        };
      });
  } else {
    selectedAdminsData = selectedAdmins.map((admin: Admin) => {
      return {
        key: admin.atlassianAccountId,
        name: admin.fullName,
        src: admin.picture,
        status: 'approved', // to show the checkCircle on the top of each avatar
      };
    });
  }

  return (
    <AdminAvatarGroupWrapper className="show-avatar">
      <AvatarGroup data={selectedAdminsData} maxCount={4} testId="show-selected-admins-avatar" />
    </AdminAvatarGroupWrapper>
  );
};
